export default __webpack_public_path__ + "media/src/assets/images/orderAccessorial-e4f516e4393f77207f67ebeeabaeb66c.svg";